import React, {Fragment, useState} from 'react';

import {ModalityCodeEnum} from 'domain/usecases';
import {RefundTaggingEnum} from 'main/analytics/gaTagsEnum';
import {AbandonFlowModal, StyledGrid} from 'presentation/components';
import {ServiceCard} from 'presentation/pages/private/refund/components/ServiceCard';
import {useRefundRequest} from 'presentation/pages/private/refund/hooks';
import {translations} from 'presentation/translations-new';
import {formatText} from 'presentation/utils';
import {useProfessionalCouncilOptionsStore} from '../../../store/useProfessionalCouncilOptionsStore';
import {ServiceCardsListProps} from './types';

const {changeServiceTypeModal} = translations['pt-br'].privateFlow.refund;

const getDataTagIdByModalityCode = (code: ModalityCodeEnum): string | undefined => {
	const modalityTagMap = {
		[ModalityCodeEnum.MEDICAL_APPOINTMENT]: RefundTaggingEnum.CLICK_TIPO_ATENDIMENTO_CONSULTA,
		[ModalityCodeEnum.SPECIAL_EXAMS]: RefundTaggingEnum.CLICK_TIPO_ATENDIMENTO_EXAMES_ESPECIAIS,
		[ModalityCodeEnum.SIMPLE_EXAMS]: RefundTaggingEnum.CLICK_TIPO_ATENDIMENTO_EXAMES_SIMPLES,
		[ModalityCodeEnum.HOSPITALIZATIONS]: RefundTaggingEnum.CLICK_TIPO_ATENDIMENTO_INTERNACAO,
		[ModalityCodeEnum.EMERGENCY]: RefundTaggingEnum.CLICK_TIPO_ATENDIMENTO_PRONTO_SOCORRO,
		[ModalityCodeEnum.THERAPIES]: RefundTaggingEnum.CLICK_TIPO_ATENDIMENTO_TERAPIAS,
	};

	return modalityTagMap[code];
};

export function ServiceCardsList({handleNextStep, data}: ServiceCardsListProps) {
	const {
		atoms,
		handleUpdateAtoms,
		handleResetStates,
		resetListRequestForms,
		resetRequests,
		resetSelectedRequestIndex,
		resetSubmitStatus,
	} = useRefundRequest();
	const resetProfessionalCouncilData = useProfessionalCouncilOptionsStore(state => state.reset);
	const [openChangeServiceTypeModal, setOpenChangeServiceTypeModal] = useState(false);
	const [modalityCode, setModalityCode] = useState<ModalityCodeEnum | undefined>(undefined);
	const [modalityDescription, setModalityDescription] = useState<string | undefined>(undefined);

	const handleSelectOption = (code: ModalityCodeEnum, description: string) => {
		handleUpdateAtoms.treatmentData({
			...atoms.treatmentData,
			modality: description,
			modalityCode: code,
		});
		handleNextStep();
		resetProfessionalCouncilData();
	};

	const handleClick = (code: ModalityCodeEnum, description: string) => {
		setModalityCode(code);
		setModalityDescription(description);
		if (atoms.treatmentData.modality && atoms.treatmentData.modality !== description) {
			setOpenChangeServiceTypeModal(true);
			return;
		}
		handleSelectOption(code, description);
	};

	const handleConfirm = () => {
		handleResetStates();
		resetSelectedRequestIndex();
		resetListRequestForms();
		resetSubmitStatus();
		resetRequests();
		if (modalityCode && modalityDescription) {
			handleSelectOption(modalityCode, modalityDescription);
		}
	};

	return (
		<Fragment>
			{data?.map(card => (
				<StyledGrid.Item lg={6} key={card.code}>
					<ServiceCard
						dataTagId={getDataTagIdByModalityCode(card.code)}
						hasMaxWidth={false}
						size="large"
						title={formatText(card.description, true)}
						onClick={() => handleClick(card.code, card.description)}
					/>
				</StyledGrid.Item>
			))}
			<AbandonFlowModal
				open={openChangeServiceTypeModal}
				setOpen={setOpenChangeServiceTypeModal}
				handleConfirm={handleConfirm}
				title={changeServiceTypeModal.title}
				headerTitle={changeServiceTypeModal.headerTitle}
				description={changeServiceTypeModal.description}
			/>
		</Fragment>
	);
}
